import { SelectionMode } from '@uifabric/utilities'
import { EntityList, EntityListProps } from 'components/EntityList'
import { Convolute } from 'model'
import { ConstrainMode } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { createFieldColumn } from 'views/helpers'

export type RuleSetListPropss = EntityListProps<Convolute>

export const RuleSetList: React.FC<RuleSetListPropss> = ({
  items,
  ...props
}) => {
  const { t } = useTranslation()
  const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])
  const columns = React.useMemo(
    () => [
      fieldColumn('type', {
        onRender: (item) => {
          return t(`field.ruleType.${item.type}`)
        },
        minWidth: 100,
        ungroupable: true,
      }),
      fieldColumn('activeRuleset', {
        onRender: (item) => item.activeRuleset && item.activeRuleset.ruleName,
        ungroupable: true,
      }),
    ],
    [fieldColumn]
  )
  return (
    <EntityList
      alternate={true}
      stickyHeader={true}
      columns={columns}
      selectionMode={SelectionMode.single}
      constrainMode={ConstrainMode.horizontalConstrained}
      items={items || []}
      {...props}
    />
  )
}
